module.exports = __webpack_public_path__ + "img/login_logo.93617758.png";